export const lineColor = '#979593';
export const defaultBorder = `1px solid ${lineColor}`;
export const backgroundColor = '';
